import { render, staticRenderFns } from "./TheProfilePage.vue?vue&type=template&id=5d95ec64"
import script from "./TheProfilePage.vue?vue&type=script&lang=js"
export * from "./TheProfilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports